import React,{Component} from "react";
import MainContainer  from "./PricingContainer/MainContainer";

class Pricing extends Component{
    render(){
        return(
            <MainContainer/>
        );
    }
}


export default Pricing;


// WEBPACK FOOTER //
// ./src/components/Pricing/Pricing.js